import * as React from "react";
import { useContext } from "react";
import { EditProjectContext } from "../EditProjectContext";
import PageMenuSwitch from "../../../Layout/PageMenu/PageMenuSwitch";

type Props = {
  disabled?: boolean;
};

export const InterimNetworkSwitch = ({ disabled }: Props) => {
  const { project, setProject } = useContext(EditProjectContext);
  return (
    <PageMenuSwitch
      label="Interim Network"
      value={project.IsInterimNetworkProject ?? false}
      onChange={(value: boolean) => {
        setProject({ ...project, IsInterimNetworkProject: value });
      }}
      disabled={disabled}
    />
  );
};
